export class VirtualClinicApi {
  constructor(protected baseUrl: string) {}

  public virtualClinics(): string {
    return `${this.baseUrl}/virtual-clinics/`;
  }

  public virtualClinicById(virtualClinicId: string): string {
    return `${this.baseUrl}/virtual-clinics/${virtualClinicId}/`;
  }

  public specialtyDepartments(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}specialty-departments/`;
  }

  public specialtyDepartment(virtualClinicId: string, sdKey: string): string {
    return `${this.specialtyDepartments(virtualClinicId)}${sdKey}/`;
  }

  public leistungsgruppenNrw(): string {
    return `${this.baseUrl}/virtual-clinics/leistungsgruppen/nrw/`;
  }

  public leistungsgruppenKHTG(): string {
    return `${this.baseUrl}/virtual-clinics/leistungsgruppen/khtg/`;
  }

  public fileOfTruth(): string {
    return `${this.baseUrl}/intuitive-fot`;
  }

  public address(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}address`;
  }

  public additionalInfo(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}additional-info`;
  }

  public annualAccount(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}annual-account`;
  }

  public caseNumbers(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}case-number`;
  }

  public fullyInpatientCases(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}fully-inpatient-cases/paged/`;
  }

  public fullyInpatientCase(virtualClinicId: string, caseId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}fully-inpatient-cases/${caseId}/`;
  }

  public staffing(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}staffing`;
  }

  public relatedVirtualClinics(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}related-virtual-clinics`;
  }

  public kostImports(virtualClinicId: string): string {
    return `${this.virtualClinicById(virtualClinicId)}kost-imports`;
  }

  public daVinciSystemIds(virtualClinicId: string): string {
    return `${this.baseUrl}/intuitive-surgical/davinci-system-ids/${virtualClinicId}`;
  }

  public opSaals(virtualClinicId: string): string {
    return `${this.baseUrl}/intuitive-surgical/op-saals/${virtualClinicId}`;
  }
}
